/** Ctrl/Cmd-click or middle-click — the "open this in a new tab" gesture, mirroring browsers. */
export function isOpenInNewTabClick(event: MouseEvent): boolean {
  return event.ctrlKey || event.metaKey || event.button === 1;
}
